'use client';

var ECVOption;
(function (ECVOption) {
    ECVOption["onlineProfile"] = "onlineProfile";
    ECVOption["attachedCV"] = "attachedCV";
})(ECVOption || (ECVOption = {}));
var EEditAction;
(function (EEditAction) {
    EEditAction["editPhone"] = "editPhone";
    EEditAction["editJobTitle"] = "editJobTitle";
    EEditAction["none"] = "none";
})(EEditAction || (EEditAction = {}));
var ESearchSetting;
(function (ESearchSetting) {
    ESearchSetting[ESearchSetting["DEFAULT"] = 0] = "DEFAULT";
    ESearchSetting[ESearchSetting["RELEVANT"] = 1] = "RELEVANT";
})(ESearchSetting || (ESearchSetting = {}));
var EUserInfoType;
(function (EUserInfoType) {
    EUserInfoType["phone"] = "phone";
    EUserInfoType["jobTitle"] = "jobTitle";
})(EUserInfoType || (EUserInfoType = {}));
var EApplyType;
(function (EApplyType) {
    EApplyType["none"] = "none";
    EApplyType["online"] = "online";
    EApplyType["lastAttachment"] = "last_attachment";
    EApplyType["attachment"] = "attachment";
    EApplyType["newAttachment"] = "new_attachment";
})(EApplyType || (EApplyType = {}));
var EOptionGroupType;
(function (EOptionGroupType) {
    EOptionGroupType["applyForm"] = "apply-popup-form";
    EOptionGroupType["other"] = "other";
})(EOptionGroupType || (EOptionGroupType = {}));
var EBlockSuggestion;
(function (EBlockSuggestion) {
    EBlockSuggestion["BasicInfo"] = "BasicInfo";
    EBlockSuggestion["Skills"] = "Skills";
    EBlockSuggestion["Educations"] = "Educations";
    EBlockSuggestion["WorkingHistories"] = "WorkingHistories";
    EBlockSuggestion["Summary"] = "Summary";
})(EBlockSuggestion || (EBlockSuggestion = {}));
var ERefreshProfile;
(function (ERefreshProfile) {
    ERefreshProfile[ERefreshProfile["Unset"] = 0] = "Unset";
    ERefreshProfile[ERefreshProfile["Daily"] = 1] = "Daily";
    ERefreshProfile[ERefreshProfile["Weekly"] = 2] = "Weekly";
})(ERefreshProfile || (ERefreshProfile = {}));
var EOnOffStatus;
(function (EOnOffStatus) {
    EOnOffStatus[EOnOffStatus["Off"] = 0] = "Off";
    EOnOffStatus[EOnOffStatus["On"] = 1] = "On";
})(EOnOffStatus || (EOnOffStatus = {}));

export { EApplyType, EBlockSuggestion, ECVOption, EEditAction, EOnOffStatus, EOptionGroupType, ERefreshProfile, ESearchSetting, EUserInfoType };
//# sourceMappingURL=types.js.map
